function updateProgress(current) {
  var total = 7;
  var pct = Math.round((current / total) * 100);
  document.getElementById('progress-fill').style.width = pct + '%';
  document.getElementById('progress-label').textContent = 'Step ' + current + ' of ' + total;
}

function nextSection(current) {
  if (current === 1) {
    var name = document.getElementById('parent-name').value.trim();
    var email = document.getElementById('parent-email').value.trim();
    if (!name || !email) { alert('Please enter your name and email to continue.'); return; }
  }
  document.getElementById('section-' + current).classList.remove('active');
  document.getElementById('section-' + (current + 1)).classList.add('active');
  updateProgress(current + 1);
  document.getElementById('assessment-form-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function prevSection(current) {
  document.getElementById('section-' + current).classList.remove('active');
  document.getElementById('section-' + (current - 1)).classList.add('active');
  updateProgress(current - 1);
  document.getElementById('assessment-form-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function getChecked(name) {
  return Array.from(document.querySelectorAll('input[name="' + name + '"]:checked')).map(function(el) { return el.value; }).join(', ');
}

function getRadio(name) {
  var el = document.querySelector('input[name="' + name + '"]:checked');
  return el ? el.value : 'Not answered';
}

function submitForm() {
  var consent = document.getElementById('email-consent').checked;
  if (!consent) { alert('Please check the consent box to receive your report.'); return; }

  var data = {
    access_key: "0eb851be-8edf-41e4-8284-531e867d4a0f",
    subject: "New Child Development Assessment Submission",
    from_name: "Smartizen Assessment Form",
    parent_name: document.getElementById('parent-name').value,
    email: document.getElementById('parent-email').value,
    heard_about: document.getElementById('heard-about').value,
    age_group: getRadio('age-group'),
    child_name: document.getElementById('child-name').value,
    child_dob: document.getElementById('child-dob').value,
    siblings: document.getElementById('siblings').value,
    parent_type: getRadio('parent-type'),
    parent_age: document.getElementById('parent-age').value,
    q3_focus_duration: getRadio('q3'),
    q4_easily_distracted: getRadio('q4'),
    q5_returns_after_distraction: getRadio('q5'),
    q6_follows_instructions: getRadio('q6'),
    q7_notices_patterns: getRadio('q7'),
    q8_problem_solving: getRadio('q8'),
    q9_adapts_to_change: getRadio('q9'),
    q10_visualization: getRadio('q10'),
    q11_resilience: getRadio('q11'),
    q12_self_regulation: getRadio('q12'),
    q13_speaks_up: getRadio('q13'),
    q14_kindness_awareness: getRadio('q14'),
    q15_cooperative: getRadio('q15'),
    q16_letter_sounds: getRadio('q16'),
    q17_rhyming: getRadio('q17'),
    q18_cvc_words: getRadio('q18'),
    q19_spelling: getRadio('q19'),
    q20_counting: getRadio('q20'),
    q21_addition_objects: getRadio('q21'),
    q22_add_subtract_10: getRadio('q22'),
    q23_place_values: getRadio('q23'),
    q25_skills_wanted: document.getElementById('q25').value,
    q26_already_tried: getChecked('q26'),
    q27_didnt_work: getChecked('q27') + (document.getElementById('q27-other').value ? ' | Other: ' + document.getElementById('q27-other').value : ''),
    q28_proud_outcomes: document.getElementById('q28').value,
    q29_consistency: getRadio('q29'),
    q30_limited_progress: getChecked('q30') + (document.getElementById('q30-other').value ? ' | Other: ' + document.getElementById('q30-other').value : ''),
    q31_confidence: getRadio('q31'),
    q32_memory_technique: getRadio('q32'),
    q33_breathing_affirmations: getRadio('q33'),
    q34_enrichment_goals: document.getElementById('q34').value,
    q35_solution_type: getRadio('q35'),
    q36_6_12_months_hope: document.getElementById('q36').value,
    q37_weekly_time: getRadio('q37'),
    q38_ready_to_act: getRadio('q38') + (document.getElementById('q38-other').value ? ' | ' + document.getElementById('q38-other').value : ''),
    q39_important_factors: getChecked('q39'),
    q40_child_interests: document.getElementById('q40').value,
    q44_family_context: document.getElementById('q44').value,
    email_consent: 'Yes - agreed to receive report and communications'
  };

  fetch("https://api.web3forms.com/submit", {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(data)
  }).then(function(res) {
    if (res.ok) {
      if (typeof Shopify !== 'undefined' && Shopify.analytics) {
        Shopify.analytics.publish("email_consent_given", {
          source: "child-development-assessment",
          age_group: data.age_group
        });
      }
      document.getElementById('section-7').style.display = 'none';
      document.getElementById('success-msg').style.display = 'block';
      document.querySelector('.progress-bar').style.display = 'none';
      document.getElementById('progress-label').style.display = 'none';
      document.getElementById('assessment-form-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      alert('Something went wrong. Please try again or email us at info@smartizen.ca');
    }
  }).catch(function() {
    alert('Something went wrong. Please try again or email us at info@smartizen.ca');
  });
}